/* eslint-disable no-console */
// BonBoZ: trạng thái thông báo đẩy của CHÍNH MÁY NÀY, đọc tại chỗ (quyền +
// có đăng ký push hay không).
//
// Dùng chung cho banner và Cài đặt cá nhân để phản ánh thay đổi ngay, không
// chờ vòng `device_status` → server → `push_health`.
import { ref } from 'vue';
import { getNotificationPermission, readPushState } from './pushHelper';

// `hasSubscription` là null khi chưa đọc.
export const devicePushState = ref({
  permission: getNotificationPermission(),
  hasSubscription: null,
});

// Đọc lại quyền, đồng bộ: banner đổi ngay trong lượt vẽ kế tiếp.
export const refreshDevicePermission = () => {
  const permission = getNotificationPermission();
  if (permission === devicePushState.value.permission) return;
  devicePushState.value = { ...devicePushState.value, permission };
};

// Đọc lại cả quyền lẫn đăng ký. Không đổi hoặc lỗi thì giữ nguyên trạng thái
// cũ. Trả trạng thái mới.
export const refreshDevicePushState = async () => {
  try {
    const { permission, subscription } = await readPushState();
    const hasSubscription = !!subscription;
    const current = devicePushState.value;
    if (
      permission !== current.permission ||
      hasSubscription !== current.hasSubscription
    ) {
      devicePushState.value = { permission, hasSubscription };
    }
  } catch (error) {
    console.warn('Push state check failed:', error);
  }
  return devicePushState.value;
};
